import Image from 'next/image';
import PropTypes from 'prop-types';
import { canResize } from '@/lib/winnerPhotos';

/**
 * A winner's photo as a flat square: no rounding, no shadow, no frame. Give
 * it a size through `className` and the shown width through `sizes`, so
 * phones fetch a small copy. The crop sits a little above centre, where
 * faces usually are.
 */
export default function WinnerPhoto({ src, alt = '', sizes, className = '', priority = false }) {
  return (
    <span
      className={`relative block shrink-0 overflow-hidden bg-[rgba(5,19,11,0.08)] ${className}`}
    >
      <Image
        src={src}
        alt={alt}
        fill
        sizes={sizes}
        priority={priority}
        unoptimized={!canResize(src)}
        className="object-cover object-[50%_30%]"
      />
    </span>
  );
}

WinnerPhoto.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  sizes: PropTypes.string.isRequired,
  className: PropTypes.string,
  priority: PropTypes.bool,
};
